module.exports = __webpack_public_path__ + "static/media/heart-dark.0d13198c.svg";